import actionTypes from './actionTypes';
import { createAuthenticatedApiInstance } from 'src/utils/api';
import { setAlert } from 'src/typescript/components/alert/actions';
import * as log from 'loglevel';

export const fetchPosts = (slug, filter = 'latest', enableFallBack = false) => {
  const POST_FILTERS = ['latest', 'popular'];
  const postsFilter = POST_FILTERS.includes(filter)
    ? filter
    : 'latest';

  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_COMMUNITY_POSTS, filter: postsFilter });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const isMember = !!currentUser
        && !!currentUser.followedCommunities.find(x => x.slug === slug);
      const api = createAuthenticatedApiInstance(getState);
      const url = `posts/${slug}/${postsFilter}`;

      const { data: posts } = !isMember
        ? await api.getPublic(url)
        : await api.get(`private/${url}`);

      // If we don’t have 5 popular posts, we change filter to 'latest'
      if (enableFallBack && filter === 'popular' && posts.length < 5) {
        return dispatch(fetchPosts(slug, 'latest'));
      }

      dispatch({
        type: actionTypes.FETCH_COMMUNITY_POSTS_SUCCESS,
        posts,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_COMMUNITY_POSTS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};

export const fetchWidgets = (slug) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_COMMUNITY_WIDGETS });
    try {
      const state = getState();
      const currentUser = state.context.currentUser;
      const url = `communities/${slug}/widgets`;
      const isMember = !!currentUser
        && !!currentUser.followedCommunities.find(x => x.slug === slug);
      const api = createAuthenticatedApiInstance(getState);
      const { data } = !isMember
        ? await api.getPublic(url)
        : await api.get(`private/${url}`);

      dispatch({
        type: actionTypes.FETCH_COMMUNITY_WIDGETS_SUCCESS,
        widgets: data,
      });
    } catch (ex) {
      log.error(ex);
      dispatch({ type: actionTypes.FETCH_COMMUNITY_WIDGETS_FAILURE, error: ex });
      dispatch(setAlert(ex.message));
    }
  };
};
